module.exports = __webpack_public_path__ + "static/media/DSC04768.dc9554ff.JPG";